// extracted by mini-css-extract-plugin
export var fullscreenPage = "TabBar-module--fullscreen-page--63856";
export var tabsWrapperStyle = "TabBar-module--tabsWrapperStyle--d003a";